import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink, useLocation, useParams } from "react-router-dom";
import {
  faFileContract,
  faTableTree,
  faTag,
  faChartSine,
  faRectangleHistoryCircleUser,
  faChevronRight,
  faChevronDown,
  faUsers,
  faIdCard,
  faMoneyBill,
  faFileInvoiceDollar,
  faReceipt,
  faBellConcierge,
  faThumbTack,
  faThumbTackSlash,
  faComputerSpeaker,
  faComputerClassic,
  faBrowsers,
  faLaptop,
  faBoxOpen
} from "@fortawesome/pro-regular-svg-icons";
import { useAuth } from "../providers/AuthContext"; // Import useAuth
import { useSidebar } from "../providers/SidebarContext";

export default function Sidebar() {
  const { isSidebarOpen, setIsSidebarOpen, tenants, agreement, agreementState, setAgreementState, isSticky, setIsSticky } = useSidebar(); // Sidebar state
  const { isRole } = useAuth(); // Destructure getAccessToken
  const { tenantPublicId } = useParams();

  const handleMouseEnter = () => setIsSidebarOpen(true); // Öppna sidebar vid hover

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('aside') === null) {
        setIsSidebarOpen(false);
      }
    };

    if(isSticky) {
      document.removeEventListener('click', handleClickOutside);

    } else {
      document.addEventListener('click', handleClickOutside);
      setIsSidebarOpen(false);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isSticky]);

  return (
    <>
      <aside
        onMouseEnter={handleMouseEnter} // Aktivera hover
        className={`left-0 bg-white border-r  border-mute-200 transition-all overflow-hidden duration-100 h-[100vh] z-10 ${isSidebarOpen ? ` ${agreementState ? "w-[28rem]" : "w-[24rem]"}` : "w-[4rem]"
          } md:block `}
        style={{
          pointerEvents: isSidebarOpen ? "auto" : "initial", // Anpassa för utfällt läge
        }}
      >
        <nav className="flex flex-col h-full relative">
       
       
          <ul className={`flex flex-col  absolute z-20 bg-white h-[100vh] pt-9 ${agreementState ? 'w-[4rem] border-r' : 'w-full'} ${!isSidebarOpen && agreementState && 'left-[-4rem]'}`}>

            <>
              <SidebarItem
                icon={<FontAwesomeIcon icon={faFileContract} />}
                level={1}
                text="Agreements"
                to={`/`}
                isSidebarOpen={isSidebarOpen && !agreementState}
              />
              <SidebarItem
                level={1}
                icon={<FontAwesomeIcon icon={faBellConcierge} />}
                text="Services"
                to={`/agreement-service`}
                isSidebarOpen={isSidebarOpen && !agreementState}
              />
              <SidebarItem
                level={1}
                icon={<FontAwesomeIcon icon={faBoxOpen} />}
                text="Hardware catalogue"
                to={`/hardware-catalogue`}
                isSidebarOpen={isSidebarOpen && !agreementState}
              />
              <SidebarItem
                level={1}
                icon={<FontAwesomeIcon icon={faRectangleHistoryCircleUser} />}
                text="Billing history"
                to={`/history-billing`}
                isSidebarOpen={isSidebarOpen && !agreementState}
              />
              <SidebarItem
                level={1}
                icon={<FontAwesomeIcon icon={faChartSine} />}
                text="Billing Overview"
                to={`/billing-overview`}
                isSidebarOpen={isSidebarOpen && !agreementState}
              />
              <SidebarItem
                level={1}
                icon={<FontAwesomeIcon icon={faMoneyBill} />}
                text="Agreement Overview"
                to={`/agreement-value-summary`}
                isSidebarOpen={isSidebarOpen && !agreementState}
              />
            </>

          </ul>

          {agreement && agreementState &&
            <ul className={`flex flex-col w-full absolute pt-9 ${agreementState && isSidebarOpen && "left-[4rem]"}`}>

              <div>
                <SidebarItem
                  icon={<FontAwesomeIcon icon={faFileContract} />}
                  text={agreement.name}
                  to={`/${agreement.agreementPublicId}`}
                  isSidebarOpen={isSidebarOpen}
                />
                {isRole("admin") && (
                  <>
                    {tenants.filter(t => t.isEnabled).length > 0 && (
                      tenants.filter(t => t.isEnabled).map((tenant) => (
                        <div key={tenant.tenantPublicId}>
                          <SidebarItem
                            key={tenant.id}
                            icon={<FontAwesomeIcon icon={faTableTree} />}
                            level={2}
                            text={tenant.displayName}
                            to={`/${agreement.agreementPublicId}/${tenant.tenantPublicId}`}
                            isSidebarOpen={isSidebarOpen}
                          />
                          {tenant.tenantPublicId === tenantPublicId && (
                            <>
                              <SidebarItem
                                icon={<FontAwesomeIcon icon={faUsers} />}
                                level={3}
                                text="Users"
                                to={`/${agreement.agreementPublicId}/${tenant.tenantPublicId}/users`}
                                isSidebarOpen={isSidebarOpen}
                              />
                              <SidebarItem
                                icon={<FontAwesomeIcon icon={faIdCard} />}
                                level={3}
                                text="Licenses"
                                to={`/${agreement.agreementPublicId}/${tenant.tenantPublicId}/licenses`}
                                isSidebarOpen={isSidebarOpen}
                              />
                            </>
                          )}
                        </div>
                      ))
                    )}
                    
                    <SidebarItem
                      icon={<FontAwesomeIcon icon={faTag} />}
                      level={2}
                      text="Add-on service"
                      to={`/${agreement.agreementPublicId}/add-on-service`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    <SidebarItem
                      icon={<FontAwesomeIcon icon={faBrowsers} />}
                      level={2}
                      text="Domains"
                      to={`/${agreement.agreementPublicId}/domains`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    {/* User devices hidden - replaced by Device inventory
                    <SidebarItem
                      icon={<FontAwesomeIcon icon={faComputerSpeaker} />}
                      level={2}
                      text="User devices"
                      to={`/${agreement.agreementPublicId}/user-devices`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    */}
                    <SidebarItem
                      icon={<FontAwesomeIcon icon={faLaptop} />}
                      level={2}
                      text="Device inventory"
                      to={`/${agreement.agreementPublicId}/device-inventory`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    <SidebarItem
                      icon={<FontAwesomeIcon icon={faComputerClassic} />}
                      level={2}
                      text="User programs"
                      to={`/${agreement.agreementPublicId}/user-programs`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    <SidebarItem
                      icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                      level={2}
                      text="Billing groups"
                      to={`/${agreement.agreementPublicId}/billing-groups`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    <SidebarItem
                      icon={<FontAwesomeIcon icon={faReceipt} />}
                      level={2}
                      text="Account types"
                      to={`/${agreement.agreementPublicId}/account-types`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    <SidebarItem
                      level={2}
                      icon={<FontAwesomeIcon icon={faChartSine} />}
                      text="Index adjustments"
                      to={`/${agreement.agreementPublicId}/indexadjustment`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    <SidebarItem
                      level={2}
                      icon={<FontAwesomeIcon icon={faRectangleHistoryCircleUser} />}
                      text="History & billing"
                      to={`/${agreement.agreementPublicId}/history-billing`}
                      isSidebarOpen={isSidebarOpen}
                    />
                    <SidebarItem
                      level={2}
                      icon={<FontAwesomeIcon icon={faMoneyBill} />}
                      text="Financial"
                      to={`/${agreement.agreementPublicId}/financial`}
                      isSidebarOpen={isSidebarOpen}
                    />
                  </>
                )}
              </div>

            </ul>
            
          }
        </nav>
      </aside>
      {isSidebarOpen && <div className="relative z-10">
          <button className="absolute top-1 right-2" onClick={() => setIsSticky(!isSticky)}>
              {isSticky ? 
              <FontAwesomeIcon icon={faThumbTackSlash} className="w-3 h-3" />
              :
               <FontAwesomeIcon icon={faThumbTack} className="w-3 h-3" />}
             
            </button>
          </div>}
    </>
  );
}

function SidebarItem({ icon, text, children, to, isSidebarOpen, level = 1, isDisabled = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleSubmenu = (e) => {
    e.preventDefault();
    setIsOpen((prev) => !prev);
  };

  const isActive = children?.some(child => location.pathname.startsWith(child.to)) || location.pathname === to || location.pathname.startsWith(`${to}/`) || (to === "/agreements" && location.pathname.startsWith("/agreement/"));

  return (
    <>
      <NavLink
        to={isDisabled ? "#" : to}
        className={`flex items-center py-3 px-6 transition-all duration-200 truncate group hover:bg-primary-300 ${isDisabled && 'pointer-events-none'} ${isSidebarOpen ? "justify-between" : "justify-center"
          } ${isActive ? "bg-primary-100" : ""} ${isActive && level === 3 ? "bg-primary-200" : ""} ${level === 3 && isSidebarOpen && "pl-16"} ${level === 2 && isSidebarOpen && "pl-12"}`}
      /* onClick={children?.length > 0 && toggleSubmenu}  */
      >
        <li className="flex items-center">
          <span className="w-6">{icon}</span>
          {isSidebarOpen && (
            <span
              className={`ml-2 transition-opacity duration-200 truncate w-[12rem] ${isSidebarOpen ? "opacity-100 visible" : "opacity-0 invisible"
                }`}
            >
              {text}
            </span>
          )}
          {children?.length > 0 && isSidebarOpen && (
            <FontAwesomeIcon
              icon={!isOpen ? faChevronRight : faChevronDown}
              className="ml-4 cursor-pointer"
              onClick={toggleSubmenu} // Only toggle submenu through chevron icon
            />
          )}
        </li>
      </NavLink>
      {children?.length > 0 && (
        <div
          className={`overflow-hidden transition-[max-height] duration-100 ${isSidebarOpen && isOpen ? "max-h-40" : "max-h-0"
            }`}
        >
          <ul className="ml-8">
            {children.map((child, index) => (
              <li key={index}>
                <NavLink
                  to={child.to}
                  className="ml-4 block py-2 px-3 hover:bg-primary-200"
                >
                  {child.text}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

